import { DataTable } from '@/components/common'
import { formatDate } from './formatters'
import styles from './igaming.module.css'

export function InsightsTable({ title, items, firstColumn = 'Key' }) {
  if (!items.length) return null
  return (
    <div className={styles.insightGroup}>
      <h3>{title}</h3>
      <DataTable
        data={items.map((item) => ({ ...item, row_key: `${item.query || item.key}-${item.last_seen_at}` }))}
        keyField="row_key"
        density="compact"
        label={title}
        columns={[
          { key: 'query', label: firstColumn, render: (row) => row.query || row.key },
          { key: 'event_count', label: 'Events', numeric: true },
          { key: 'searches', label: 'Searches', numeric: true },
          { key: 'clicks', label: 'Clicks', numeric: true },
          { key: 'last_seen_at', label: 'Last seen', render: (row) => formatDate(row.last_seen_at) },
        ]}
      />
    </div>
  )
}
